import React from "react";
import { Helmet } from "react-helmet";
import { useCompanyStore } from "stores";
//helpers
import { truncate } from "helpers";
import seoConfig from "../../config/seoConfig";

const Head = (props) => {
  const { name } = useCompanyStore();

  let domainSeoConfig = null;
  if (typeof window !== "undefined") {
    const baseHost = window.location.hostname;
    const port = window.location.port ? `:${window.location.port}` : "";
    const hostKey =
      process.env.NODE_ENV === "development" ? `${baseHost}${port}` : baseHost;
    domainSeoConfig = seoConfig[hostKey] || null;
  }

  let metaTitle = "";
  if (domainSeoConfig?.title) {
    metaTitle = `${domainSeoConfig.title} | ${domainSeoConfig.description}`;
  } else if (props.home) {
    metaTitle = name + " | Venta de Libros, Ebooks y Más";
  } else if (props?.title?.indexOf("Productos") !== -1) {
    metaTitle = `${props.title} | ${name}`;
  } else {
    metaTitle = props.title || "";
  }

  // Obtener la URL actual para canonical y Open Graph
  const currentUrl = typeof window !== 'undefined' ? window.location.href : '';
  const imageUrl = props.image || props.ogImage || '';
  const baseDescription = domainSeoConfig?.description
    ? domainSeoConfig.description
    : props.description || "";
  const metaDescription = truncate(baseDescription, 180);

  return (
    <div className="application">
      <Helmet>
        {props.noIndex ? (
          <meta name="robot" content="noindex, nofollow" />
        ) : null}
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#000000" />
        <meta name="title" content={metaTitle} />
        <meta
          name="description"
          content={metaDescription}
        />
        <title>{metaTitle}</title>
        
        {/* Canonical URL */}
        {props.canonical && <link rel="canonical" href={props.canonical} />}
        {!props.canonical && currentUrl && <link rel="canonical" href={currentUrl} />}
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content={props.ogType || "website"} />
        <meta property="og:url" content={props.ogUrl || currentUrl} />
        <meta property="og:title" content={props.ogTitle || metaTitle} />
        <meta property="og:description" content={props.ogDescription || metaDescription} />
        {imageUrl && <meta property="og:image" content={imageUrl} />}
        {imageUrl && <meta property="og:image:width" content="1200" />}
        {imageUrl && <meta property="og:image:height" content="630" />}
        {name && <meta property="og:site_name" content={name} />}
        
        {/* Twitter Card */}
        <meta name="twitter:card" content={props.twitterCard || "summary_large_image"} />
        <meta name="twitter:url" content={props.twitterUrl || currentUrl} />
        <meta name="twitter:title" content={props.twitterTitle || metaTitle} />
        <meta name="twitter:description" content={props.twitterDescription || metaDescription} />
        {imageUrl && <meta name="twitter:image" content={imageUrl} />}
      </Helmet>
    </div>
  );
};

export default Head;
